<template>
    <div class="freight-terms">
        <b-row>
            <b-col cols="12 ">
                <div class="title flex">
                    Freight Terms
                    <div class="red">*</div>
                    <small
                        v-if="!this.value.collect && !this.value.prepaid"
                        class="text-danger"
                        >Please select at least one checkbox.</small
                    >
                </div>
            </b-col>
        </b-row>

        <b-card class="b-card-bg">
            <b-row class="px-2 custom-row">
                <b-col cols="12" lg="5">
                    <div class="container-checkbox">
                        <validation-provider
                            name="prepaid"
                            #default="{ errors }"
                            rules=""
                        >
                            <b-form-group>
                                <input
                                    :disabled="readonly"
                                    type="checkbox"
                                    class="custom-checkbox-new"
                                    v-model="value.prepaid"
                                    @change="handleChange(1)"
                                />
                            </b-form-group>
                        </validation-provider>

                        <div>
                            <div class="text-black">Prepaid</div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="5">
                    <div class="container-checkbox">
                        <validation-provider
                            name="collect"
                            #default="{ errors }"
                            rules=""
                        >
                            <b-form-group>
                                <input
                                    :disabled="readonly"
                                    type="checkbox"
                                    class="custom-checkbox-new"
                                    v-model="value.collect"
                                    @change="handleChange(2)"
                                />
                            </b-form-group>
                        </validation-provider>

                        <div>
                            <div class="text-black">Collect</div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row> </b-row>
        </b-card>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import { BFormGroup, BRow, BCol, BCard } from "bootstrap-vue";
export default {
    components: {
        Select2,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BRow,
        BCol,
        BCard,
    },
    props: {
        value: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            R: true,
        };
    },
    computed: {
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
        ]),
    },
    methods: {
        handleChange(id) {
            if (id === 1 && this.value.collect) {
                this.value.prepaid = true;
                this.value.collect = false;
            } else if (id === 2 && this.value.prepaid) {
                this.value.collect = true;
                this.value.prepaid = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.freight-terms {
    label {
        color: #000000;
        font-weight: 600;
    }
    .form-group {
        margin-bottom: 0;
    }
    .b-card-bg {
        height: 100px;
        @media (max-width: 992px) {
            height: 200px;
        }
        .custom-row {
            align-items: baseline;
            justify-content: center;
        }
        .container-checkbox {
            display: flex;
            gap: 5px;
            justify-items: center;
            align-items: center;
            @media (max-width: 992px) {
                height: 70px;
            }
        }
        .text-black {
            color: #000000;
            font-weight: 600;
            margin-bottom: 0;
        }
    }
    //   .select2 {
    //     height: 28px !important;
    //   }
    .mx-datepicker-popup {
        .mx-shortcuts-wrapper {
            display: none;
        }
        .mx-range-wrapper {
            max-width: 100vw;
            .mx-calendar {
                float: none;
                .mx-calendar-content {
                    width: auto;
                }
            }
        }
    }
}
</style>
